import React from "react"
import { createPerformanceTableTool } from "@/editor/createPerformanceTableTool"

export const SmallPerformanceByStageTableTool = createPerformanceTableTool({
  type: "small_performance_by_stage_table",
  headerText: "Performance by Stage",
  columnHeader: "Stage",
  dataProperty: "stage",
  toolboxTitle: "Stage Performance Table",
})
